import { useAtom } from "jotai";
import React from "react";
import ReactConfetti from "react-confetti";

import { useTheme } from "@mui/material";

import { StoreConfetti } from "../../store/store";

export const Confetti: React.FC = () => {
  const [confettiState] = useAtom(StoreConfetti);
  const { palette, zIndex } = useTheme();

  if (!confettiState.isActive) return null;

  return (
    <ReactConfetti
      width={window.innerWidth}
      height={window.innerHeight}
      colors={[palette.primary.dark]}
      numberOfPieces={300}
      recycle={false}
      gravity={0.25}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: zIndex.tooltip + 100, // Above tooltips
        pointerEvents: "none",
      }}
    />
  );
};
